import { Box, Dialog, DialogContent, Paper } from '@mui/material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { VegaLite } from 'react-vega';
import { DialogTitle } from './DialogTitle';
import { Map } from '../sections/field-agrilytics/Map';

function PaperComponent(props) {
  const ref = useRef({});

  return (
    <Draggable
      nodeRef={ref}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper ref={ref} {...props} />
    </Draggable>
  );
}

export function GeometryViewer(props) {
  const {
    title,
    onClose,
    geojson,
    aaid,
    growerId,
    fieldBoundaryId,
    endsAt,
    isCertified,
    tabbedViewer = false,
    tabs = null,
    hideBackdrop = true,
  } = props;

  const [selectedTab, setSelectedTab] = useState(() => {
    if (tabs) return setInitialTab();
  });

  const handleTabChange = (event, newTab) => {
    setSelectedTab(tabs.find((tab) => tab.value === newTab));
  };

  const isGoogleable = Boolean(aaid && isCertified);

  return (
    <Dialog
      open
      maxWidth={isGoogleable ? 'md' : 'sm'}
      fullWidth={isGoogleable}
      hideBackdrop={hideBackdrop}
      PaperProps={{ sx: { pointerEvents: 'auto' } }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      sx={{
        pointerEvents: 'none',
        '& #draggable-dialog-title': {
          backgroundColor: 'inherit',
          display: 'inherit',
        },
      }}
    >
      {tabbedViewer && (
        <>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mr: 2,
            }}
          >
            <Tabs value={selectedTab.value} onChange={handleTabChange}>
              {tabs.map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} />
              ))}
            </Tabs>

            <IconButton
              edge="end"
              color="inherit"
              onClick={onClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <DialogContent>{buildVegaMap(selectedTab.geojson)}</DialogContent>
        </>
      )}

      {!tabbedViewer && (
        <>
          <DialogTitle
            sx={{ cursor: 'move' }}
            id="draggable-dialog-title"
            title={title}
            onClose={onClose}
          />
          <DialogContent>{buildMap()}</DialogContent>
        </>
      )}
    </Dialog>
  );

  function setInitialTab() {
    const tfs = tabs.find((tab) => tab.value === 'tfs');
    return tfs || tabs.find((tab) => tab.value === 'jd');
  }

  function buildMap() {
    return isGoogleable ? buildGoogleMap() : buildVegaMap(geojson);
  }

  function buildGoogleMap() {
    return (
      <Box sx={{ width: '100%', height: 600 }}>
        <Map
          boundary={geojson}
          aaid={aaid}
          growerId={growerId}
          boundaryId={fieldBoundaryId}
          endsAt={endsAt}
        />
      </Box>
    );
  }

  function buildVegaMap(geometry) {
    const mapSpec = {
      height: 200,
      width: 300,
      padding: 5,
      mark: { type: 'geoshape' },
      projection: { type: 'mercator' },
      data: {
        values: {
          type: 'FeatureCollection',
          features: [{ type: 'Feature', properties: {}, geometry }],
        },
        format: { type: 'json', property: 'features' },
      },
    };

    return (
      <div data-testid={`${selectedTab?.value || 'field'}-boundary`}>
        <VegaLite spec={mapSpec} />
      </div>
    );
  }
}
